'use strict';

module.exports = [
  {
    messageKey: 'js.modules.login.enter_password',
    validateFn: value => !!value,
  },
];
